import React, { Component } from "react";
import "./editalumni.css";
import { Input, Modal, Button, Tabs, Row, Col, Steps, Spin, Icon, Alert, Collapse, Form, Select, Divider, Result, DatePicker } from "antd";
import moment from "moment";
import Iframe from "../HOC/iframe";
import * as actions from "../../actions/index";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import NESARegistrations from "./NESARegistrations";
import SAFRegistrations from "./SAFRegistration";
import InputMask from "react-input-mask";
import warningAlert from "../BulkUpload/warning-alert.png";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const { Step } = Steps;
const CHASE_URL = process.env.REACT_APP_CHASE;

const steps = [
  {
    title: "Information"
  },
  {
    title: "Payment"
  },
  {
    title: "Receipt"
  }
];
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const Panel = Collapse.Panel;
const { TextArea } = Input;
const Option = Select.Option;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const customPanelStyle = {
  background: "#fff",
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: "hidden"
};
let modalActive = false;
const NESA_MID = process.env.REACT_APP_NESA_MID;
class Memberships extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      MembershipsModal: false,
      receipt_loading: false,
      Membership: "",
      SelectedMembership: "",
      Ethinic: "",
      startdate: undefined,
      enddate: "",
      current: 0,
      seconds: 20,
      InitPayresponse: {},
      AlumniRegresponse: {},
      TotalAmount: 0,
      email: "",
      PhoneNumber: "",
      Address: "",
      isShowConflictPopUp: false,
      hasConflict: false,
      loadingTransactionModal: false,
      shoppingCartAmount: 0,
      isCreatedApplication: false,
      isNesaManualFee: false,
      disableFields: false
    };
    this.showMembershipModal = this.showMembershipModal.bind(this);
    this.handleChangeMembership = this.handleChangeMembership.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.closemodal = this.closemodal.bind(this);
    window.showAdminReceiptComponent = this
  }

  resetModalState = () => {
    this.props.form.resetFields();

    this.setState({
      MembershipsModal: false,
      current: 0,
      disableFields: false,
      Membership: "",
      SelectedMembership: "",
      Ethinic: "",
      startdate: undefined,
      enddate: "",
      TotalAmount: 0,
      shoppingCartAmount: 0,
      isCreatedApplication: false,
      receipt_loading: false,
      isRegistrationSuccess: false,
      isShoppingCartSuccess: false,
      isPaymentSuccess: false
    });
  };

  next() {
    const current = this.state.current + 1;
    this.setState({ current, disableFields: true });
    this.props.actions.getEthnicities()
  }

  prev() {
    const current = this.state.current - 1;
    this.setState({ current, disableFields: true });
    this.props.actions.getEthnicities()
  }

  showLoadingReceipt = () => {
    this.setState({
      receipt_loading: true
    });
    this.loadingInterval = setInterval(() => {
      const { seconds, minutes } = this.state;

      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.loadingInterval);
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59
          }));
        }
      }
    }, 1000);
  };

  showMembershipModal = value => {
    // this.props.form.resetFields();
    let personethnicity = "";
    let Ethinic = "";
    let personemail = "";
    let personphone = "";
    let startDate = "";
    let address = ""
    if (this.props.profileinfo) {
      personethnicity = this.props.profileinfo.extendedProfile.filter(
        data => data.attributeId == "1"
      )[0];
      if (personethnicity) {
        let ethnicitiesArray = this.props.ethnicities;
        ethnicitiesArray.map((k, index) => {
          if (k.short == personethnicity.attributeVal) {
            Ethinic = k.name;
          }
        });
      }
      if (Array.isArray(this.props.profileinfo.emails) && this.props.profileinfo.emails.length > 0) {
        personemail = this.props.profileinfo.emails.filter(
          data =>
            (typeof data.isPrimary === "string" &&
              data.isPrimary.toLowerCase() === "true") ||
            (typeof data.isPrimary === "boolean" && data.isPrimary)
        )[0];
      }
      if (Array.isArray(this.props.profileinfo.phones) && this.props.profileinfo.phones.length > 0) {
        personphone = this.props.profileinfo.phones.filter(
          data => data.isPrimary == "True"
        )[0];
      }
      if (Array.isArray(this.props.profileinfo.address) && this.props.profileinfo.address.length > 0) {
        address = this.props.profileinfo.addresses.filter(
          data => data.isPrimary == "True"
        )[0];
      }
    }
    if (value && this.props.nesa_reg.length != 0) {
      startDate = this.getMembershipsMaxDate();
    }
    modalActive = true;
    this.setState({
      MembershipsModal: value,
      startdate: moment().isBefore(startDate) ? moment(startDate).add('days', 1).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY'),
      Ethinic: Ethinic,
      email: personemail,
      PhoneNumber: personphone,
      Address: address,
      current: 0,
      disableFields: false
    });
  };

  getMembershipsMaxDate = () => new Date(
    Math.max(
      ...this.props.nesa_reg.map(reg => { if (reg.expireDate) return new Date(reg.expireDate) })
    )
  );

  onDateChange = date => {
    this.setState({ startdate: date }, () => {
      const { startdate, SelectMembership } = this.state;
  
      if (startdate.length === 10 && SelectMembership && SelectMembership.toString() === "30") {
        const proposedEndDate = moment(startdate).add(5, 'years').subtract(1, 'day').format('YYYY-MM-DD');
        console.log("proposedEndDate", proposedEndDate);
        this.checkNesaRegistrationConflicts(proposedEndDate);
      }
    });
  };


  closemodal = () => {
    if (this.props.response && !modalActive) {
      if (this.state.MembershipsModal && !modalActive) {
        this.setState({
          MembershipsModal: false
        });
      }
      this.props.form.resetFields();
    }
  };

  handleChangeMembership = e => {
    this.setState({
      Membership: e,
      SelectedMembership: ""
    });
    if (e == "11") {
      this.props.actions.getNESAmembershiplevels();
    }
    if (e == "10") {
      this.props.actions.getSAFmembershiplevels();
    }
  };

  showConflictPopUpModal = () => {
    this.setState({
      isShowConflictPopUp: true,
    });
  };

  closeConflictPopUpModal = () => {
    this.setState({
      isShowConflictPopUp: false,
    });
  };

  SelectMembership = e => {
    const { Membership, startdate } = this.state;
  
    // Update selected membership in state
    this.setState({ SelectMembership: e }, () => {
      if (Membership === "11") {
        let values = {
          ethnic_background: this.state.Ethinic,
        }
        if (e === "30") { // NESA Bronze Membership (5 years)
          const proposedEndDate = moment(startdate).add(5, 'years').subtract(1, 'day').format('YYYY-MM-DD');
          console.log("proposedEndDate", proposedEndDate);
  
          // Check for conflicts with existing NESA registrations
          this.checkNesaRegistrationConflicts(proposedEndDate);
  
        } else if (e === "32") { // NESA LifeTime Membership
          // const proposedStartDate = moment().format('MM/DD/YYYY');
          // const { setFieldsValue } = this.props.form;
          // setFieldsValue({
          //   start_date: proposedStartDate
          // });
          const proposedStartDate = this.state.startdate;
          this.setState((prevState) => ({ startdate: proposedStartDate, enddate: undefined,  hasConflict: false })); // Set enddate to undefined for lifetime membership
        }
      } else if (Membership === "10") { // SAF Memberships
        const endDate = moment(startdate).add(1, 'years').format('YYYY-MM-DD');
        this.setState({ enddate: endDate }); // Update enddate for SAF memberships
      }
    });
  };
  
  //function to check conflicts with existing NESA registrations
  checkNesaRegistrationConflicts = (proposedEndDate) => {
    const { nesa_reg } = this.props;
  
    const isConflicted = nesa_reg.find(reg => {
      const effectiveDate = moment(reg.effectiveDate);
      const expiryDate = moment(reg.expireDate);
  
      return (
        (!moment(effectiveDate).isSame(expiryDate)) &&
        ((moment(this.state.startdate).isSameOrAfter(effectiveDate) && moment(proposedEndDate).isBefore(expiryDate)) ||
        (moment(this.state.startdate).isSameOrBefore(expiryDate) && effectiveDate.isBefore(moment(proposedEndDate))))
      );
    });
  
    if (isConflicted) {
      this.showConflictPopUpModal();
      this.setState({ hasConflict: true, enddate: undefined }); // Clear enddate if there is a conflict
    } else {
      this.setState({ enddate: proposedEndDate, hasConflict: false }); // No conflicts, update enddate and clear hasConflict
    }
  };

  handleCashSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const MID = this.props.profileinfo.profile.memberId;
        this.state.SelectMembership
        this.props.actions.CashPayment(this.props.personGUID, this.state.TotalAmount, this.state.AlumniRegresponse, this.state.InitPayresponse, values.cash_bill_number, this.state.startdate, this.state.enddate, MID, this.state.SelectMembership, this.state.isNesaManualFee)
      }
    })
  }

  registerApplication = () => {
    const { getFieldValue } = this.props.form;
    // const start_date = getFieldValue('start_date');
    // const ethnic_background = getFieldValue('ethnic_background');
    // const affiliate = getFieldValue('affiliate');
    const type = getFieldValue('type');

    if (type || this.state.SelectedMembership) {
    }
  }
  
  handleSubmit = e => {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {

        if (!this.props.eagleinfo.eagleBoardReviewDate) {
          Modal.error({
            className: "ErrorModal",
            title: 'Missing Information!',
            content: `Scout's Board Of Review Date is missing!`
          });

          this.setState({
            loadingTransactionModal: false,
          });

          return; 
        }

        let person_ethnic = values.ethnic_background;
        let ethnicitiesArray = this.props.ethnicities;

        ethnicitiesArray.map((k) => {
          if (k.name == person_ethnic) {
            values.ethnic_background = k.id;
          }
        });

        this.setState({
          TotalAmount: values.payment_amount,
          loadingTransactionModal: true
        });

        this.setState({
          isRegistrationSuccess: false,
          isShoppingCartSuccess: false,
          isPaymentSuccess: false
        });

        this.props.actions.AddMembership(
          this.props.profileinfo,
          this.state.Membership,
          this.state.SelectMembership,
          this.props.eagleinfo,
          values,
          this.state.startdate,
          this.state.enddate
        );

        modalActive = false;
      }
    });
  };

  ethnicities = () => {
    if (this.props.ethnicities) {
      let ethnicitiesArray = this.props.ethnicities;
      return ethnicitiesArray.map((k, index) => {
        return (
          <option key={index} value={k.id}>
            {k.name}
          </option>
        );
      });
    }
  };

  InitTrans = () => {
    this.props.actions.InitOrbitalPayments(this.state.TotalAmount, "ADMIN NESA", NESA_MID, this.state.AlumniRegresponse, this.state.email.email, this.state.InitPayresponse, null, this.state.isNesaManualFee);
  };

  checkActiveMembership = (nesaRegProps) => {
    let nesaRegistrations = nesaRegProps.length > 0 ? nesaRegProps : this.props.nesa_reg;
    // if (this.props.nesa_reg_updating) {
    //   return <Spin indicator={LoadingIcon} className="loading-state" tip="Updating NESA Membership..." />
    // }
    // if (this.props.nesa_reg_loading) {
    //   return <Spin indicator={LoadingIcon} className="loading-state" tip="Loading NESA Membership..." />
    // }

    if (nesaRegistrations && this.props.nesa_levels) {
      let nesa_reg_sorted = nesaRegistrations
      nesa_reg_sorted.sort(function (a, b) {
        return b.isActive - a.isActive;
      });
      //   return nesa_reg_sorted.map((j, jIndex) => {
      //     let nesalevels = this.props.nesa_levels
      //     let curDate = new Date();
      //     let nesalevel_name = ''
      //     nesalevels.map((k, index) => {
      //       if (k.id == j.programId) nesalevel_name = k.name
      //     })
      //     const { getFieldDecorator } = this.props.form;
      //     if (j.expireDate == null && j.programId.toString() == '32') {
      //       return this.setState({
      //         isActiveMembership: true
      //       })
      //     }
      //   })
      let curDate = new Date();
      const isActiveMembership = nesa_reg_sorted.find(reg => reg.programId == 32 && moment(curDate).isSameOrAfter(reg.effectiveDate) && (reg.expireDate == null
        // || moment(curDate).isSameOrBefore(reg.expireDate)
      ))
      isActiveMembership ? this.setState({
        isActiveMembership: true
      }) : this.setState({
        isActiveMembership: false
      })
    }
  }

  deepComparision = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false; // If the arrays have different lengths, they are not equal.
    }

    // Sort the arrays to ensure order consistency (optional step).
    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();

    for (let i = 0; i < sortedArr1.length; i++) {
      const obj1 = sortedArr1[i];
      const obj2 = sortedArr2[i];

      if (!this.objectsAreEqual(obj1, obj2)) {
        return false; // If any pair of objects is not equal, the arrays are not equal.
      }
    }

    return true; // If all objects in both arrays are equal, the arrays are equal.


  }
  objectsAreEqual = (objA, objB) => {
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
      return false; // If the objects have different numbers of properties, they are not equal.
    }

    for (let key of keysA) {
      if (!objB.hasOwnProperty(key) || objA[key] !== objB[key]) {
        return false; // If any property values differ, the objects are not equal.
      }
    }

    return true; // If all properties and their values are equal, the objects are equal.
  }

  componentDidMount = () => {
    this.props.actions.getEagleInfo();
    this.props.actions.getEthnicities();
    this.props.actions.getNESAmembershiplevels();
    this.props.actions.getSAFmembershiplevels();
  };

  componentWillReceiveProps = nextprops => {
    if (this.props.InitPayresponse !== nextprops.InitPayresponse) {
      if (nextprops.InitPayresponse) {
        // this.next();
        this.setState({
          InitPayresponse: nextprops.InitPayresponse,
          AlumniRegresponse: nextprops.AlumniRegresponse,
          isRegistrationSuccess: true
        }
        // , () => {
        //   this.InitTrans();
        // }
        )
      }
    }
    if ((this.props.creatingApplicationError !== nextprops.creatingApplicationError) && nextprops.creatingApplicationError) {
        this.setState({
          loadingTransactionModal: false
        })
        this.props.actions.receiveAddMembershipError(false); //TO clear the error message from reducer state
    }
    if ((this.props.CashPayment !== nextprops.CashPayment) || (this.props.regstatus !== nextprops.regstatus )) {
      if ((nextprops.CashPayment) || (nextprops.regstatus) ) {
        this.setState({
          current: 2
        })
      }
    }
    if (this.props.shoppingCartList !== nextprops.shoppingCartList && nextprops.shoppingCartList) {
      let TotalAmount = nextprops.shoppingCartList.totalAmountDue
      this.setState({
        shoppingCartAmount: TotalAmount,
        TotalAmount,
        isCreatedApplication: true, 
        loadingTransactionModal: false,
        isShoppingCartSuccess: true,
        current: 1,
        disableFields: true
      })
    }
    if (this.props.paymentSuccess !== nextprops.paymentSuccess && nextprops.paymentSuccess) {
      this.setState({
        isPaymentSuccess: true
      });
    }
    // AAG-1378: isActiveMembership pre-calculation disabled along with the Add New Membership button it fed
    // if (nextprops.nesa_reg && this.props.nesa_levels) {
    //   if (!this.deepComparision(this.props.nesa_reg, nextprops.nesa_reg)) {
    //   nextprops.nesa_reg.length !== 0 && this.checkActiveMembership(nextprops.nesa_reg);
    //   }
    // }
  };

  changeEthinicity = e => {
    this.setState({
      Ethinic: e
    });
  };

  renderLevels = () => {
    if (this.state.Membership == "11") {
      if (this.props.saflevels_loading) {
      }
      if (this.props.nesa_levels) {
        let nesalevels = this.props.nesa_levels;
        return nesalevels.map((k, index) => {
          return <Option value={k.id}>{k.name.replace(/-/g, " ")}</Option>;
        });
      }
    }
    if (this.state.Membership == "10") {
      if (this.props.saflevels) {
        let saflevels = this.props.saflevels;
        return saflevels.map((k, index) => {
          return <Option value={k.id}>{k.name.replace(/-/g, " ")}</Option>;
        });
      }
    }
  };

  renderNesaLevels = () => {
    if (this.props.nesa_levels) {
      let nesalevels = this.props.nesa_levels;
      return nesalevels.map((k, index) => {
        return <Option value={k.id}>{k.name.replace(/-/g, " ")}</Option>;
      });
    }
  };

  renderSAFLevels = () => {
    if (this.props.saflevels) {
      let saflevels = this.props.saflevels;
      return saflevels.map((k, index) => {
        return <Option value={k.id}>{k.name.replace(/-/g, " ")}</Option>;
      });
    }
  };

  handleNESAmembership = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log(values);
      }
    });
  };

  renderAddMembership = () => {
    const { profileinfo, isSuperAlumniAdmin } = this.props;

    if (!isSuperAlumniAdmin) return null;

    if (profileinfo) {
      if (profileinfo.profile.isDeceased) {
        return (
          <Alert
            message="Constituent is deceased and membership cannot be applied"
            type="info"
            showIcon
          />
        );
      }

      return (
        <Button
          type="primary"
          id="mem-add-btn"
          className="add-membership-btn"
          onClick={e => {
            e.stopPropagation();
            this.showMembershipModal(true);
          }}
          disabled={true} // AAG-1378: Add New Membership flow disabled
        >
          <Icon type="plus-circle-o" /> ADD NEW MEMBERSHIP
        </Button>
      );
    }

    return null;
  };

  renderIframe = () => {
    if (this.props.initloading == true) {
      return (
        <Row>
          <Col span={24}>
            <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Chase Payments..." />
          </Col>
        </Row>
      );
    } else if (this.props.registration_loading) {
      return (
        <Row>
          <Col span={24}>
            <Spin indicator={LoadingIcon} className="loading-state" tip="Loading Please Wait..." />
          </Col>
        </Row>
      );
    } else if (this.props.initTransaction) {
      return (
        <Row className="chase-payment">
          <Col span={24}>
            <Iframe src={`${CHASE_URL}` + this.props.initTransaction.uID} height="700px" width="100%" />
          </Col>
        </Row>
      );
    }
  };

  // renderReceiptpage = () => {
  //   if (this.props.regstatus) {
  //     this.setState({
  //       current: 2
  //     })
  //   }
  // }

  showReceipt = (RegID, response) => {
    // this.props.actions.getNESARegistrations(this.props.personGUID, true);
    const profileDetails = {...this.props.profileinfo.profile};
    profileDetails.MembershipType = this.state.SelectMembership;
    const MID = this.props.profileinfo.profile.memberId;
    
    setTimeout(
      function () {
        this.props.actions.getRegStatusandSendReceipt(RegID, profileDetails, "ADMIN NESA", this.state.email.email, response, null, MID)
      }
        .bind(this),
      15000
    );
  }

  finalSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(
      ["start_date", "ethnic_background", "affiliate", "type"],
      (err, values) => {
        if (!err) {
          this.handleSubmit();
        }
      }
    );
  };

  render() {
    const { current, seconds } = this.state;
    const Option = Select.Option;
    const { getFieldDecorator } = this.props.form;
    const { isShowConflictPopUp } = this.state;
    const { hasConflict } = this.state;
    return (
      <div className="maintain-membership">
        <Collapse
          defaultActiveKey={"1"}
          accordion
          style={{ border: "none", backgroundColor: "inherit" }}
        >
          <Panel
            header="National"
            key="1"
            style={customPanelStyle}
            // extra={this.renderAddMembership()} //AG-1378
          >
            {/* National */}
            <Row gutter={48}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <fieldset style={{ padding: "20px" }}>
                  <legend>NESA Memberships:</legend>
                  <NESARegistrations personGUID={this.props.personGUID} />
                </fieldset>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <fieldset style={{ "margin-top": "20px", padding: "20px" }}>
                  <legend>SAF Memberships:</legend>
                  <SAFRegistrations personGUID={this.props.personGUID} />
                </fieldset>
              </Col>
            </Row>
          </Panel>
        </Collapse>

        <Modal title=""
          centered
          closable={false}
          style={{backgroundColor: "transparent", display: 'flex', alignItems:'center' }}
          className="Creating-application-model"
          visible={this.state.loadingTransactionModal}
          footer={false}
        >
          <Spin indicator={antIcon} tip='Creating application...' />
        </Modal>
        {/* AAG-1378: previous Add New Membership flow disabled, replaced by non-revenue membership enrollment */}
        {false && (
        <Modal
          title="Add New Membership"
          centered
          closable={false}
          className="add-membership-modal"
          visible={this.state.MembershipsModal}
          footer={false}
        >
          <div>
            <Steps className="admin-membership" size="small" current={current}>
              {steps.map(item => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
            <div className="steps-content">{steps[current].content}</div>
            <div className="steps-action">
              {current == 0 && (
                <Form className='m-t-20' layout="vertical" onSubmit={this.finalSubmit}>
                  <Row gutter={48} type="flex" justify="center" align="center">
                    <Col span={12}>
                      <FormItem label="Start Date"
                        hasFeedback
                        validateStatus={this.state.showCustomErr ? "error" : undefined}
                        help={this.state.CustomDateErrMsg ? this.state.CustomDateErrMsg : undefined}
                      >
                        {getFieldDecorator("start_date", {
                          initialValue: this.state.startdate ? moment(this.state.startdate).format('MM/DD/YYYY') : '',
                          rules: [
                            {
                              required: true,
                              message: "Enter Membership Start Date!"
                            },
                            {
                              validator: (rule, value, callback) => {

                                if (!value) {
                                  callback();
                                  return;
                                }

                                if (value.indexOf("_") !== -1) {
                                  callback("Please complete the date");
                                  return;
                                }

                                if (!moment(value, "MM/DD/YYYY", true).isValid()) {
                                  callback("Please enter a valid date");
                                  return;
                                }

                                callback();
                              }
                            }
                          ]
                        })(
                          // <DatePicker style={{ width: '100%' }} onChange={this.onDateChange} />
                          <InputMask
                            mask="99/99/9999"
                            // onBlur={(e) => this.onDateChange(e.target.value)}
                            onChange={(e) => this.onDateChange(e.target.value)}
                            onBlur={e => {
                              this.setState({startdate: e.target.value});
                            }}
                            placeholder="MM/DD/YYYY"
                            alwaysShowMask
                            maskChar={null}
                            className="ant-input width-100"
                            render={(ref, props) => (
                              <Input {...props} disabled={this.state.disableFields} />
                            )}
                          />
                        )}
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Ethnic Background">
                        {getFieldDecorator("ethnic_background", {
                          initialValue:
                            this.state.Ethinic == "" ? "" : this.state.Ethinic,
                          rules: [
                            {
                              required: true,
                              message: "Enter your Ethnic Background!"
                            }
                          ]
                        })(
                          <Select
                            disabled={this.state.disableFields}
                            style={{ width: "100%" }}
                            onChange={() => {
                              this.changeEthinicity();
                            }}
                          >
                            {this.ethnicities()}
                          </Select>
                        )}
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Affiliate">
                        {getFieldDecorator("affiliate", {
                          rules: [
                            {
                              required: true,
                              message: "Enter Membership Affiliate!"
                            }
                          ]
                        })(
                          <Select
                            disabled={this.state.disableFields}
                            style={{ width: "100%" }}
                            onChange={this.handleChangeMembership}
                          >
                            <Option value="11">NESA</Option>
                            {/* <Option value="10">SAF</Option> */}
                          </Select>
                        )}
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Type">
                        {getFieldDecorator("type", {
                          initialValue: this.state.SelectedMembership,
                          rules: [
                            {
                              required: true,
                              message: "Enter Membership Type!"
                            }
                          ]
                        })(
                          <Select
                            disabled={this.state.disableFields}
                            loading={
                              this.props.saflevels_loading ||
                                this.props.nesa_levels_loading
                                ? true
                                : false
                            }
                            placeholder="Select a Membership Type"
                            style={{ width: "100%" }}
                            onChange={this.SelectMembership}
                          >
                            {this.renderLevels()}
                          </Select>
                        )}
                      </FormItem>
                    </Col>
                    {/* <Col span={12}>
                      <FormItem label="Receipt Number">
                        {getFieldDecorator("receipt_number", {
                          rules: [
                            {
                              required: true,
                              message: "Enter Membership Receipt Number!"
                            }
                          ]
                        })(
                          <Input type="number" placeholder="Receipt Number" />
                        )}
                      </FormItem>
                    </Col> */}
                    <Col span={24}>
                      <FormItem label="Notes">
                        {getFieldDecorator("notes", {
                          rules: [
                            {
                              required: false,
                              message: "Enter Membership Notes!"
                            }
                          ]
                        })(<TextArea rows={4} disabled={this.state.disableFields}/>)}
                      </FormItem>
                    </Col>
                  </Row>
                  <Row type="flex" justify="space-between">
                    <Col xs={24} sm={24} md={8} lg={8}>
                      <FormItem>
                        <Button
                          id="show-mem-modal"
                          // loading={this.props.loading ? true : false}
                          className=" modal-btn"
                          onClick={ this.resetModalState }
                        >
                          Cancel
                        </Button>
                      </FormItem>
                    </Col>

                    <Col xs={24} sm={24} md={8} lg={8}>
                      <FormItem>
                        <Button
                          id="mem-su-btn"
                          className="primary-btn modal-btn"
                          htmlType="submit"
                        >
                          Submit
                        </Button>
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
              )}
              {current == 1 && (
                // <Tabs>
                //   <TabPane tab={ <div> <Icon type="dollar" /> Cash / Cheque </div> } key="1" >
                //     <Divider orientation="left">Payment Details for ${this.state.TotalAmount}</Divider>
                <div className="payment-div">
                    <Form layout="vertical" onSubmit={this.handleCashSubmit}>
                      <Row gutter={24}>
                        <Col xs={24} sm={12}>
                          <FormItem label="Payment Amount">
                            {getFieldDecorator("payment_amount", {
                              initialValue: this.state.shoppingCartAmount || undefined,
                              rules: [
                                {
                                  required: true,
                                  message: "Please enter Payment Amount!"
                                },
                                {
                                  validator: (rule, value, callback) => {
                                    if (
                                      value === undefined ||
                                      value === null ||
                                      value === ""
                                    ) {
                                      callback();
                                      return;
                                    }

                                    if (Number(value) <= 0) {
                                      callback("Payment Amount must be greater than 0");
                                      return;
                                    }

                                    callback();
                                  }
                                }
                              ]
                            })(
                              <Input
                                type="number"
                                addonBefore={<Icon type="dollar" />}
                                placeholder="Payment Amount"
                                onChange={(e) => {
                                  const isNesaManualFee =
                                    e.target.value.toString() !==
                                    this.state.shoppingCartAmount.toString();

                                  this.setState({
                                    isNesaManualFee,
                                    TotalAmount: e.target.value
                                  });
                                }}
                              />
                            )}
                          </FormItem>
                        </Col>

                        <Col xs={24} sm={12}>
                          <FormItem label="Check Number">
                            {getFieldDecorator("cash_bill_number", {
                              rules: [
                                {
                                  required: true,
                                  message: "Please Enter Check Number!"
                                }
                              ]
                            })(
                              <Input placeholder="Check Number" />
                            )}
                          </FormItem>
                        </Col>
                      </Row>
                      <Row type="flex" justify="center" align="center">
                        <Col span={6} offset={1}>
                          <FormItem>
                            <Button id="mem-paymetn-btn"
                              // loading={this.props.loading ? true : false}
                              className="modal-btn" onClick={() => this.prev()} >
                              Back
                            </Button>
                          </FormItem>
                        </Col>
                        <Col span={6} offset={1}>
                          <FormItem>
                            <Button loading={this.props.CashPayment_loading} className="primary-btn modal-btn" htmlType="submit" >
                              Complete
                            </Button>
                          </FormItem>
                        </Col>
                      </Row>
                    </Form>
                  {/* </TabPane> */}
                  {/* </TabPane> */}
                  {/* <TabPane tab={<div> <Icon type="credit-card" /> Credit card </div>} key="2" >
                    <Spin tip={`Please do not close the browser until the Receipt is displayed! \n  Redirecting in ${seconds} seconds...`} style={{ whiteSpace: "break-spaces" }} spinning={this.state.receipt_loading} >
                      {this.renderIframe()}
                    </Spin>
                  </TabPane> */}
                  {/* <div>
                    {this.renderReceiptpage()}
                  </div> */}
                {/* </Tabs> */}
                </div>
              )}
              {current == 2 && (
                <Result
                  status="success"
                  title="Successfully Membership Added!"
                  //subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
                  extra={[
                    <Button id="mem-modal-cl" onClick={this.resetModalState} type="primary" key="console">
                      Close
                    </Button>
                  ]}
                />
              )}
            </div>
          </div>
        </Modal>
        )}
        <Modal
          className="No-records-Found-model"
          title=""
          visible={isShowConflictPopUp}
          centered
          footer={false}
          closable={false}
          onCancel={this.closeConflictPopUpModal}
        >
          <div className="center">
            <div>
              <img src={warningAlert} alt="warning" width="40px" height="40px" />
            </div>
            <div className="margin-bottom-20" style={{ marginTop: "20px" }}>
              The attempted membership's start date adjustment conflicts with an existing membership.
              Please review the other memberships for this member and make appropriate adjustments
              to avoid overlapping dates.
            </div>
            <Button
              key="close" type="primary"
              style={{ backgroundColor: '#003366', borderColor: '#fff', borderRadius: '28px', padding: '15px 35px 34px 35px' }}
              onClick={this.closeConflictPopUpModal} >
              CLOSE
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    nesa_levels_loading: state.nesalevelsreducer.loading,
    nesa_levels: state.nesalevelsreducer.levels,
    saflevels_loading: state.saflevelsreducer.loading,
    saflevels: state.saflevelsreducer.levels,
    profileinfo: state.alumniinforeducer.profileinfo,
    eagleinfo: state.alumnieagleinforeducer.eagleinfo,
    ethnicities_loading: state.ethnicitiesreducer.loading,
    ethnicities: state.ethnicitiesreducer.ethnicities,
    loading: state.addmembershipreducer.loading,
    creatingApplicationError: state.addmembershipreducer.error,
    InitPayresponse: state.addmembershipreducer.response,
    AlumniRegresponse: state.addmembershipreducer.regresponse,
    error_res: state.addmembershipreducer.error,
    nesa_reg_loading: state.nesaregistrationreducer.loading,
    nesa_reg: state.nesaregistrationreducer.reg,
    saf_reg_loading: state.safregistrationreducer.loading,
    saf_reg: state.safregistrationreducer.reg,
    initloading: state.chasepaymentreducer.loading,
    initTransaction: state.chasepaymentreducer.initTransaction,
    regstatus: state.regstatusreducer.status,
    CashPayment_loading: state.cashPaymentreducer.loading,
    CashPayment: state.cashPaymentreducer.response,

    gettingShoppingcart: state.shoppingCartReducer.loading,
    shoppingCartList: state.shoppingCartReducer.response,
    paymentSuccess: state.addmembershipreducer.paymentSuccess,
    isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

const Membership = Form.create()(Memberships);

export default connect(mapStateToProps, mapDispatchToProps)(Membership);


// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/Memberships.js